export default __webpack_public_path__ + "static/media/avatar.b7686993.svg";